import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import constants from 'src/constants';
import DisableSelectToolNotification from './notificationComponents/DisableSelectToolNotification';
import EnableSelectToolNotification from './notificationComponents/EnableSelectToolNotification';
import SaveNotification from './notificationComponents/SaveNotification';
import { NotificationContainer } from './styled';

const {
  DISABLE_SELECT_TOOL_NOTIFICATION,
  ENABLE_SELECT_TOOL_NOTIFICATION,
  SAVE_NOTIFICATION,
} = constants.notification;

const components = {
  [DISABLE_SELECT_TOOL_NOTIFICATION]: DisableSelectToolNotification,
  [ENABLE_SELECT_TOOL_NOTIFICATION]: EnableSelectToolNotification,
  [SAVE_NOTIFICATION]: SaveNotification,
};

const mapStateToProps = ({ designPro }) => ({
  notification: designPro.notification.notification,
});

export class Notification extends PureComponent {
  static propTypes = {
    notification: PropTypes.shape({
      type: PropTypes.string,
      isVisible: PropTypes.bool.isRequired,
    }).isRequired,
  };

  render() {
    const { type, isVisible } = this.props.notification;
    const NotificationComponent = components[type];
    if (!isVisible) return null;

    return (
      <NotificationContainer
        isVisible={isVisible}
        data-selenium="notificationText"
      >
        {NotificationComponent && <NotificationComponent />}
      </NotificationContainer>
    );
  }
}

export default connect(mapStateToProps)(Notification);
